import { classNames, tv } from "../../utils"

export const overlayVariants = tv({
  base: classNames(
    "fixed inset-0 z-overlay bg-overlay ease-out-quint",
    "data-[state=open]:animate-in data-[state=closed]:animate-out",
    "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
  ),
  variants: {
    open: {
      true: "animate-in fade-in-0",
      false: "animate-out fade-out-0",
    },
  },
})
